export class AddVideoCardBenchmarkRequest  {
    VideoCardName: string;
    BenchmarkScore: number;
}
